import { createAction, props } from '@ngrx/store';

export const setPreviousRoute = createAction('[App][Core] set previous route', props<{ previousRoute: string }>());

export const setReturnRoute = createAction('[App][Core] set return route', props<{ returnRoute: string }>());
export const clearReturnRoute = createAction('[App][Core] clear return route');
